import { render } from "./TransparentButton.vue?vue&type=template&id=c51ab0f4&scoped=true&ts=true"
import script from "./TransparentButton.vue?vue&type=script&lang=ts"
export * from "./TransparentButton.vue?vue&type=script&lang=ts"

import "./TransparentButton.vue?vue&type=style&index=0&id=c51ab0f4&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51ab0f4"]])

export default __exports__